import React, { Component } from 'react';
import { Chip, SxProps, Theme } from '@mui/material';

import { DisplayUser } from './VisibleUserSelect';

interface Color {
  red: number;
  green: number;
  blue: number;
}

// https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
function parseColor(hex: string): Color {
  const parsedInt = parseInt(hex.replace('#', ''), 16);

  return {
    red: (parsedInt >> 16) & 255,
    green: (parsedInt >> 8) & 255,
    blue: parsedInt & 255,
  };
}

// https://www.w3.org/TR/AERT/#color-contrast
// https://en.wikipedia.org/wiki/Relative_luminance
function getPerceptiveLuminance(color: Color) {
  return 1 - (0.299 * color.red + 0.587 * color.green + 0.114 * color.blue) / 255;
}

interface Props {
  user: DisplayUser;
  onHideClick: (userId: string) => void;
  sx: SxProps<Theme>;
}

export default class UserChip extends Component<Props> {
  onHideClick = () => {
    this.props.onHideClick(this.props.user.id);
  };

  render() {
    return (
      <Chip
        label={this.props.user.name}
        key={this.props.user.name}
        style={{
          backgroundColor: this.props.user.color,
          color: getPerceptiveLuminance(parseColor(this.props.user.color)) < 0.5 ? '#000000' : '#FFFFFF',
        }}
        onDelete={this.onHideClick}
        sx={this.props.sx}
      />
    );
  }
}
